import { call, put, takeEvery } from 'redux-saga/effects';

import { CONVEYACING_STATUS_COMPLETED, REDUX_STORE } from '@funnels/constants';
import {
  CreateConveyancingIntentAction,
  FetchConveyancingAction,
  ServerConveyancingFetchResponse,
  StoreConveyancing,
} from '@funnels/types';
import { datadogUtil } from '@funnels/utils';

import { waitForAuth } from '../_common';
import { createConveyancingIntentFail, createConveyancingIntentSuccess, fetchConveyancingSuccess } from './actions';
import { createConveyancingIntent, fetchConveyancingByPropertyId, fetchConveyancingIntent } from './api';

export function* fetchConveyancingWorker(action: FetchConveyancingAction): any {
  try {
    yield waitForAuth();

    const { payload } = action;
    const response = yield call(fetchConveyancingByPropertyId, payload.property.id);
    const enquiries: ServerConveyancingFetchResponse = response || [];

    let storeConveyancing: StoreConveyancing;

    const completedEnquiry = enquiries.find((enquiry) => enquiry.lendiStatus === CONVEYACING_STATUS_COMPLETED);

    if (completedEnquiry) {
      storeConveyancing = { ...completedEnquiry, intent: 'YES' };
    } else {
      // If there isn't a completed status, call intent API for intent option.
      try {
        const intentResponse = yield call(fetchConveyancingIntent, payload);
        const matchEnquiryToIntent = enquiries.find((enquiry) => enquiry.property.id === intentResponse.linkedEntityId);
        if (matchEnquiryToIntent) {
          storeConveyancing = { ...matchEnquiryToIntent, intent: intentResponse.intent };
        } else {
          const matchPropertyToIntent = intentResponse.linkedEntityId === payload.property.id;
          if (matchPropertyToIntent) {
            storeConveyancing = { property: { id: payload.property.id }, intent: intentResponse.intent };
          } else {
            storeConveyancing = { ...payload };
          }
        }
      } catch (e) {
        storeConveyancing = { ...payload };
      }
    }
    yield put(fetchConveyancingSuccess(storeConveyancing));
  } catch (e: any) {
    datadogUtil.addError(e);
    yield put(createConveyancingIntentFail());
  }
}

export function* createConveyancingIntentWorker(action: CreateConveyancingIntentAction): any {
  try {
    yield waitForAuth();

    const { payload } = action;
    const response = yield call(createConveyancingIntent, payload);

    const enquiryId = response?.draftEnquiryId || '';

    yield put(createConveyancingIntentSuccess(enquiryId));
  } catch (e: any) {
    datadogUtil.addError(e);
    yield put(createConveyancingIntentFail());
  }
}

export function* conveyancingWatcher() {
  yield takeEvery(REDUX_STORE.CONVEYANCING.ACTION_TYPES.FETCH_CONVEYANCING, fetchConveyancingWorker);
  yield takeEvery(REDUX_STORE.CONVEYANCING.ACTION_TYPES.CREATE_CONVEYANCING_INTENT, createConveyancingIntentWorker);
}

export default conveyancingWatcher;
